import React, { useState, useEffect } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import EvvReport from "./EVVReports/EVVReport";
import EvvInvoice from "./EVVReports/EVVInvoice";

export default function EVV_Reports(props) {
    const [activeKey, setActiveKey] = useState("evvReport");

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    useEffect(() => {
        setActiveKey(props.activeSubKey)
    }, [props.activeSubKey]);

    return (
        <div style={{width: '100%'}}>
            <div>
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                        fontFamily: "Lato",
                        marginBottom: 10,
                        marginLeft: 10
                    }}
                >
                    EVV Reports
                </Typography>
            </div>
            <div style={{width: '100%'}}>
                <Tabs
                    value={activeKey}
                    onChange={handleKeyChange}
                    variant="scrollable"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .Mui-selected': {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                            width: 'inherit'
                        }
                    }}
                >
                    {props.user.permissions.EVVReport && <Tab key={"evvReport"} value={"evvReport"} label="EVV Report" />}
                    {props.user.permissions.EVVInvoice && <Tab key={"evvInvoice"} value={"evvInvoice"} label="EVV Invoice" />}
                </Tabs>

                <div style={{width: '100%'}}>
                {activeKey === "evvReport" && <EvvReport {...props} />}
                {activeKey === "evvInvoice" && <EvvInvoice {...props} />}
                </div>
            </div>
        </div>
    )
};